/**
 * Para onde o "Voltar" do detalhe do chamado leva (spec 2026-09-27-chamados-revisao-geral §7).
 *
 * O detalhe abre da Entrada, de Meus chamados, da Organização, de Todos, da GMUD, de
 * notificação e do chat: só o histórico sabe de onde a pessoa veio. Sem histórico na
 * aplicação (react-router marca a primeira entrada com key 'default' — link em aba nova ou
 * vindo de e-mail) o destino é a Entrada, primeiro item do menu de Chamados.
 */
export const VOLTAR_SEM_HISTORICO = '/chamados/inbox'

export function destinoDoVoltar(locationKey: string): -1 | typeof VOLTAR_SEM_HISTORICO {
  return locationKey === 'default' ? VOLTAR_SEM_HISTORICO : -1
}
